import {Dialog, Paper, styled} from '@mui/material'

export const DialogCustomStyled = styled(Dialog)(({disableShadow}: any) => ({
  '.MuiPaper-root': {
    borderRadius: '16px',
    alignSelf: 'baseline',
    width: '100%',
    boxShadow: disableShadow && 'none',
    border: disableShadow && '1px solid lightgrey'
  },
  '.MuiTypography-root': {
    padding: 0
  },
  '.MuiDialogContent-root': {
    padding: 0
  },
  '.MuiDialogActions-root': {
    padding: 0
  },
  '.MuiBackdrop-root': {
    backgroundColor: disableShadow && 'transparent'
  }
}))

// NOTE: dimensions are fixed px values (not theme.spacing(n)) on purpose.
// This component is shared by legacy pages and new-style pages, whose themes
// use different spacing base units (legacy: 2, new: 8). Using theme.spacing(n)
// made the dialog chrome balloon to ~4x its intended padding when rendered
// inside ThemeProviderNew (e.g. the "Lista pazienti" dialog).
export const DialogPaperStyled = styled(Paper)(() => ({
  '.dialog-header': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 30px'
  },
  '.dialog-title': {
    margin: 0
  },
  '.dialog-body': {
    padding: '0 30px'
  },
  '.dialog-footer': {
    padding: '20px 30px'
  }
}))
